module.exports = __webpack_public_path__ + "static/media/arrow-red.b5138d51.svg";